/* eslint-disable @typescript-eslint/naming-convention */
import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, mergeMap } from 'rxjs';

import { AuthenticationService } from '../services/authentication.service';

export const tokenInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn) => {
  return from(inject(AuthenticationService).getToken()).pipe(
    mergeMap(token => {
      const isFormData = request.body instanceof FormData;
      const headers: Record<string, string> = {};

      if (token) {
        headers.Authorization = `Bearer ${token}`;
        if (!isFormData) {
          headers['Content-Type'] = request.headers.get('Content-Type') || 'application/json';
        }
        request = request.clone({ setHeaders: headers });
      }

      return next(request);
    }),
  );
};
